import dayjs from "dayjs";

export const formatDate = (date) => {
  if (!date) return "";

  // Firestore Timestamp instance
  if (date.toDate && typeof date.toDate === "function") {
    return dayjs(date.toDate()).format("DD-MM-YYYY");
  }

  // De-serialized { seconds, nanoseconds }
  if (typeof date === "object" && "seconds" in date) {
    const ms = date.seconds * 1000 + Math.floor((date.nanoseconds || 0) / 1e6);
    return dayjs(ms).format("DD-MM-YYYY");
  }

  // JS Date
  if (date instanceof Date) return dayjs(date).format("DD-MM-YYYY");

  // ISO / string
  if (typeof date === "string") {
    const d = dayjs(date);
    return d.isValid() ? d.format("DD-MM-YYYY") : "";
  }

  return "";
};
